import * as React from "react";
import {Filter, List, TextField, TextInput,} from "react-admin";
import CustomDataGrid from "../CustomElements/CustomDataGrid";
import {CustomActionsButtons} from "../CustomElements/CustomActionButtonsField";
import CustomActionBar from "../CustomElements/CustomActionBar";
import {CustomPagination} from "../CustomElements/CustomPagination";

import EmptyList from "../EmptyList";

export default (props) => {
  return (
    <List
      {...props}
      title={`kategorie faq`}
      perPage={25}
      pagination={<CustomPagination />}
      bulkActionButtons={false}
      actions={<CustomActionBar />}
      empty={<EmptyList title="kategorie faq" add={true} />}
      filters={
        <Filter>
          <TextInput
            label="Pytanie"
            source="question"
            variant="outlined"
            alwaysOn
            resettable
          />
        </Filter>
      }
    >
      <CustomDataGrid>
        <TextField source="question" label="Pytanie" />

        {/*<ReferenceField source="type" reference="faq_types" label="Kategoria">*/}
        {/*  <SingleFieldList>*/}
        {/*    <ChipField source="name" />*/}
        {/*  </SingleFieldList>*/}
        {/*</ReferenceField>*/}

        <CustomActionsButtons label="Akcje" notUndoable={true} />
      </CustomDataGrid>
    </List>
  );
};
